import { render } from "./BuscaAvancada.vue?vue&type=template&id=7ddefaf4&scoped=true&ts=true"
import script from "./BuscaAvancada.vue?vue&type=script&lang=ts"
export * from "./BuscaAvancada.vue?vue&type=script&lang=ts"

import "./BuscaAvancada.vue?vue&type=style&index=0&id=7ddefaf4&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddefaf4"]])

export default __exports__